import React from 'react';
import { getPasswordStrength } from '../../utils/passwordValidation';
import './Auth.scss';

interface PasswordStrengthProps {
  password: string;
}

export const PasswordStrength: React.FC<PasswordStrengthProps> = ({ password }) => {
  const strength = getPasswordStrength(password);

  if (!password) {
    return null;
  }

  return (
    <div className="auth-strength">
      <div className="auth-strength-header">
        <span className="auth-strength-label">Password strength</span>
        <span className="auth-strength-value">{strength.label}</span>
      </div>
      <div className="auth-strength-bar">
        <div
          className="auth-strength-fill"
          style={{ width: `${strength.percent}%` }}
          role="progressbar"
          aria-valuenow={strength.percent}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Password strength: ${strength.label}`}
        />
      </div>
      <p className="auth-strength-hint">
        Use 15+ characters with uppercase, lowercase, numbers and symbols.
      </p>
    </div>
  );
};
